import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';

const Header = () => {
  const { user, logout } = useAuth();
  const { totalCount } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!menuOpen) return;
    const handleClick = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [menuOpen]);

  return (
    <header className="relative z-[80] bg-gradient-to-r from-[#0f2f75] via-primary to-[#153f92] text-white shadow-lg shadow-primary/25">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
        <div className="flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center group gap-3">
            <img
              src={logo}
              alt="Теплогранд"
              className="h-12 w-12 object-contain drop-shadow-md"
            />
            <div className="flex flex-col">
              <span className="text-2xl font-extrabold tracking-tight group-hover:text-secondary-light transition-colors">Теплогранд</span>
              <span className="text-xs text-blue-100">Инженерные решения: отопление и водоснабжение</span>
            </div>
          </Link>

          <div className="flex items-center space-x-3 md:space-x-6">
            <div className="hidden lg:flex items-center space-x-4">
              <div className="flex flex-col items-end">
                <a href="tel:88002505710" className="hover:text-secondary-light transition-colors font-semibold text-lg leading-none">
                  8 800 250 57 10
                </a>
                <span className="text-xs text-blue-100">Пн-Пт: 9:00-18:00</span>
              </div>
              <span className="text-blue-200">|</span>
              <a href="mailto:info@teplogrand.pro" className="hover:text-secondary-light transition-colors text-sm">
                info@teplogrand.pro
              </a>
            </div>

            <div className="relative" ref={menuRef}>
              <button
                type="button"
                onClick={() => setMenuOpen((open) => !open)}
                className="flex items-center gap-2 rounded-full bg-white/10 hover:bg-white/20 px-3 py-2 text-sm font-semibold"
              >
                <span>{user ? user.name || user.email || 'Аккаунт' : 'Войти'}</span>
              </button>
              {menuOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white text-slate-800 rounded-xl shadow-2xl overflow-hidden z-[90] ring-1 ring-black/10">
                  {user ? (
                    <>
                      <Link to="/orders" onClick={() => setMenuOpen(false)} className="block px-4 py-2 hover:bg-slate-50">Мои заказы</Link>
                      <button type="button" onClick={() => { logout(); setMenuOpen(false); }} className="w-full text-left px-4 py-2 hover:bg-slate-50">Выйти</button>
                    </>
                  ) : (
                    <>
                      <Link to="/login" onClick={() => setMenuOpen(false)} className="block px-4 py-2 hover:bg-slate-50">Войти</Link>
                      <Link to="/register" onClick={() => setMenuOpen(false)} className="block px-4 py-2 hover:bg-slate-50">Регистрация</Link>
                    </>
                  )}
                </div>
              )}
            </div>

            <Link to="/cart" className="relative rounded-full bg-white/10 hover:bg-white/20 p-2.5" aria-label="Корзина">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l3-8H6.4M7 13l-1.2 6h12.4M7 13L5.4 5M10 21a1 1 0 100-2 1 1 0 000 2zm8 0a1 1 0 100-2 1 1 0 000 2z" />
              </svg>
              {totalCount > 0 && (
                <span className="absolute -top-1 -right-1 min-w-[1.25rem] h-5 px-1 rounded-full bg-secondary text-primary-dark text-xs font-bold flex items-center justify-center">
                  {totalCount}
                </span>
              )}
            </Link>

            <Link
              to="/callback"
              className="hidden sm:inline-flex bg-secondary hover:bg-secondary-light text-primary-dark font-bold px-6 py-2.5 rounded-full transition-all transform hover:scale-105 hover:shadow-xl hover:shadow-black/20"
            >
              Заказать звонок
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
